import styled, { css } from 'styled-components'

const cardVariants = {
	default: css`
		background: ${props => props.theme.colors.brand.white};
		border: 1px solid ${props => props.theme.colors.greys.dividerGray};
		color: ${props => props.theme.colors.text.primaryText};
	`,
	guard: css`
		background: ${props => props.theme.colors.feedback.errorLight};
		border: 1px solid ${props => props.theme.colors.feedback.errorHover};
		color: ${props => props.theme.colors.feedback.error};

		&:hover {
			box-shadow: 0 4px 12px rgba(218, 30, 40, 0.18);
		}
	`,
	onsite: css`
		background: ${props => props.theme.colors.brand.lightGreen};
		border: 1px solid ${props => props.theme.colors.brand.green};
		color: ${props => props.theme.colors.brand.darkGreen};

		&:hover {
			box-shadow: 0 4px 12px rgba(0, 151, 126, 0.18);
		}
	`
}

export const CardContainer = styled.div`
	border-radius: 20px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	gap: 16px;
	padding: 16px;
	width: 100%;
	cursor: pointer;
	transition: transform 0.08s ease-in-out, box-shadow 0.15s;

	${({ $type = 'default' }) => cardVariants[$type] || cardVariants.default}

	&:active {
		transform: scale(0.97);
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
	}
`

export const QuickAccessCardListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 10px 0px;
`

export const IconContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	gap: 8px;
`

export const RightIconContainer = styled.div`
	align-items: center;
	display: flex;
	justify-content: center;
`
